import { OPCOOptions } from '@/types/Services.types';

const OPCO = process.env.GATSBY_OPCO;


export default function handleTranslation(ie:string,pt:string){
    return OPCO !== OPCOOptions.PORTUGAL ? ie : pt
  }